module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_9005.5b4ecba2.png";